import { createContext, useState } from "react";

const initialState = {
    currentTab: 'buy'
};

export const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
    const [currentState, setCurrentState] = useState(initialState);

    function changeTab(newTab) {
        setCurrentState((oldState) => ({ ...oldState, currentTab: newTab }));
    };

    return (
        <DashboardContext.Provider value={{
            currentTab: currentState.currentTab,
            changeTab: changeTab,
        }}>
            {children}
        </DashboardContext.Provider>
    );
};